module.exports = __webpack_public_path__ + "static/media/amanat-nagari.fff9138b.png";